/**
 * Faithful port of eb-ui `packages/eds/eds-share-box/src/constants.js`
 * (the version social-share@0.8.40 pinned: eds-share-box@1.4.5).
 *
 * WHY REIMPLEMENTED (not the `legacy-eds.share-box@3.1.0` bridge): the bridge
 * rewrote the wire — `new URL().searchParams` encoding (`+` for spaces, `%27`
 * for apostrophes) instead of url-lib's `encodeURIComponent` (`%20`, literal
 * `'`), renamed props (`eventId`→`resourceId`), and changed the email subject
 * copy ("Check out {name}" vs "You're invited to %(eventName)s"). The
 * share-intent URLs are this package's wire contract and must byte-match the
 * eb-ui source, so we port eds-share-box@1.4.5 verbatim and keep url-lib.
 * (Everything around the wire — icons, IconButton — still uses bridges.)
 *
 * The prop-type shapes from the source are dropped: this port is TypeScript
 * (interfaces in types.ts) and prop-types is a React-16-era runtime checker.
 */

export const SHARE_ON_EMAIL = 'email';
export const SHARE_ON_FACEBOOK = 'facebook';
export const SHARE_ON_FACEBOOK_MESSENGER = 'facebookMessenger';
export const SHARE_ON_LINKEDIN = 'linkedin';
export const SHARE_ON_TWITTER = 'twitter';
export const SHARE_ON_WHATSAPP = 'whatsapp';

// share components should be ordered as: facebook, facebookMessenger, twitter, email
// don't change the order unless you're totally sure about what you're doing
export const SHARE_TYPES = [
    SHARE_ON_FACEBOOK,
    SHARE_ON_FACEBOOK_MESSENGER,
    SHARE_ON_LINKEDIN,
    SHARE_ON_TWITTER,
    SHARE_ON_EMAIL,
    SHARE_ON_WHATSAPP,
];

export const DEFAULT_SHARE_TYPES = [
    SHARE_ON_FACEBOOK,
    SHARE_ON_FACEBOOK_MESSENGER,
    SHARE_ON_TWITTER,
    SHARE_ON_EMAIL,
];

export const DEFAULT_UTM_OPTIONS = {
    'utm-campaign': 'social',
    'utm-content': 'attendeeshare',
    'utm-medium': 'discovery',
    'utm-source': '',
    'utm-term': 'checkoutwidget',
};

export const UTM_SHARE_TYPE_MAP: Record<string, Record<string, string>> = {
    [SHARE_ON_FACEBOOK]: { 'utm-source': 'fb' },
    [SHARE_ON_FACEBOOK_MESSENGER]: { 'utm-source': 'fbm' },
    [SHARE_ON_LINKEDIN]: { 'utm-source': 'li' },
    [SHARE_ON_TWITTER]: { 'utm-source': 'tw' },
    [SHARE_ON_EMAIL]: {
        'utm-campaign': 'social,email',
        'utm-source': 'strongmail',
    },
    [SHARE_ON_WHATSAPP]: { 'utm-source': 'wa' },
};

export const EMAIL_AFFILIATED_CODE: Record<string, string> = {
    default: 'eivtefrnd',
    organizer: 'odeieiemailshare',
};

export const FACEBOOK_AFFILIATED_CODE: Record<string, string> = {
    default: 'esfb',
    organizer: 'odsjfcfb',
};

export const FACEBOOK_MESSENGER_AFFILIATED_CODE: Record<string, string> = {
    default: 'ebdsshmessenger',
    organizer: 'odsjfcmessenger',
};

export const TWITTER_AFFILIATED_CODE: Record<string, string> = {
    default: 'estw',
    organizer: 'odsjtwtweet',
};

export const DATA_HEAP_ID = 'share-event-method';

export const DATA_SHARE_METHOD_MAP: Record<string, string> = {
    [SHARE_ON_FACEBOOK]: 'facebook',
    [SHARE_ON_FACEBOOK_MESSENGER]: 'messenger',
    [SHARE_ON_TWITTER]: 'twitter',
    [SHARE_ON_EMAIL]: 'email',
    [SHARE_ON_LINKEDIN]: 'linkedin',
    [SHARE_ON_WHATSAPP]: 'whatsapp',
};
